import { render, staticRenderFns } from "./StaticPage2.vue?vue&type=template&id=0ae8dc27&scoped=true"
import script from "./StaticPage2.vue?vue&type=script&lang=js"
export * from "./StaticPage2.vue?vue&type=script&lang=js"
import style0 from "./StaticPage2.vue?vue&type=style&index=0&id=0ae8dc27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8dc27",
  null
  
)

export default component.exports